import {
  ConsumoDto,
  FaixaConsumoTipoValorEnum,
} from "core/features/consumo/typings";

export function getValorConsumo(
  consumoUnidade: number,
  consumo: ConsumoDto
): number {
  const faixasConsumo = consumo.faixas;

  const medidaConsumo = Math.max(consumoUnidade, 0);

  let valorConsumoUnidade = 0;

  if (faixasConsumo?.length) {
    const faixasOrdenadas = [...faixasConsumo].sort((a, b) => {
      if (a.fimFaixa === null && b.fimFaixa === null) return 0;
      if (a.fimFaixa === null) return 1;
      if (b.fimFaixa === null) return -1;

      return a.inicioFaixa! - b.inicioFaixa!;
    });

    let consumoRestante = medidaConsumo;

    for (const faixa of faixasOrdenadas) {
      const inicioFaixa = faixa.inicioFaixa ?? 0;
      const fimFaixa = faixa.fimFaixa ?? Infinity;

      const consumoNaFaixa = Math.min(consumoRestante, fimFaixa - inicioFaixa);

      const temConsumoNaFaixa = consumoNaFaixa > 0;
      const consumoNaFaixaInicialZerado =
        consumoNaFaixa === 0 && inicioFaixa === 0;

      if (temConsumoNaFaixa || consumoNaFaixaInicialZerado) {
        valorConsumoUnidade +=
          faixa.tipoValor === FaixaConsumoTipoValorEnum.ValorFixo
            ? faixa.valor
            : consumoNaFaixa * faixa.valor;
      }

      consumoRestante -= consumoNaFaixa;
      if (consumoRestante <= 0) break;
    }
  } else {
    valorConsumoUnidade = medidaConsumo * (consumo.valorUnidade ?? 0);
  }

  return valorConsumoUnidade;
}
